import React, { Suspense  } from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n.js";
import "./global.css";
import App from "./App.js";
import {
    ApolloClient,
    ApolloProvider,
    InMemoryCache,
    HttpLink,
} from "@apollo/client";
import WcipProvider from "./context";
const link = new HttpLink({
    uri: window.globalConfig.VITE_GRAPHQL_URL,
    useGETForQueries: false,
});
const client = new ApolloClient({
    link: link,
    cache: new InMemoryCache({ addTypename: false }),
});

createRoot(document.getElementById("root")).render(

        <Suspense>
            <I18nextProvider i18n={i18n}>
                <ApolloProvider client={client}>
                    <WcipProvider>
                        <App />
                    </WcipProvider>
                </ApolloProvider>
            </I18nextProvider>
        </Suspense>

);
